export const FILTER_SHOPIFY_ORDERS_BY_DATE = "FILTER_SHOPIFY_ORDERS_BY_DATE";
export const SET_SHOPIFY_ORDERS_BY_DATE = "SET_SHOPIFY_ORDERS_BY_DATE";
export const SET_SHOPIFY_ORDERS_COMPARE_DATA =
  "SET_SHOPIFY_ORDERS_COMPARE_DATA";
